export { Login as default } from 'features/College'
